import React, { Component } from 'react';
import { Modal, Form, TextArea, Button, Icon, Header } from 'semantic-ui-react';
import _ from 'lodash';
import Collapsable from './Collapsable';
import IconButton from './IconButtons';

class AddUrlsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlsToAdd: this.props.urlsToAdd || ""
    }
    this.onUrlChange = this.onUrlChange.bind(this);
  }

  getUrlArray = () => {
    const urlArr = _.split(_.trim(this.state.urlsToAdd), /[ ,\n]+/);
    if (_.last(urlArr).length < 1) return _.slice(urlArr, 0, urlArr.length - 1);
    return urlArr;
  }

  handleDone = () => {
    const urlArr = this.getUrlArray();
    this.setState({urlsToAdd: ""});
    if (urlArr.length > 0) this.props.addUrls(urlArr);
    this.props.onDone && this.props.onDone();
  }

  onUrlChange = (e, data) => {
    this.setState({ urlsToAdd: data.value })
  }

  render() {
    return (
      <Modal
        open={this.props.open}
        className="scrolling add-url-modal small"
        dimmer={'inverted'}>
        { this.props.open  && <Collapsable handleDone={this.handleDone}/> }
        <IconButton
          name="cancel"
          className="modal-cancel-button"
          onClick={this.props.onCancel}
        />
        <Modal.Content>
          <Form onSubmit={this.addUrls}>
            <Header as='h6'>
              Save entries to Winno:
            </Header>
            <TextArea
              autoHeight
              placeholder="Enter urls separated by comma or space"
              rows={2}
              onChange={this.onUrlChange}
              value={this.state.urlsToAdd}
            />
          </Form>
          <Button
            onClick={this.handleDone}
            primary
            icon
            className="submit-button">
            <Icon name="checkmark" />
          </Button>
        </Modal.Content>
      </Modal>
    )
  }
}

export default AddUrlsModal;



// WEBPACK FOOTER //
// ./src/components/AddUrlsModal.js